import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface GenericPreviewCardProps {
  data: Record<string, unknown>;
}

export function GenericPreviewCard({ data }: GenericPreviewCardProps) {
  const entries = Object.entries(data).filter(
    ([, value]) => value !== null && value !== undefined && typeof value !== 'object',
  );

  return (
    <Card>
      <CardHeader className="p-4 pb-2">
        <CardTitle className="text-sm">Preview</CardTitle>
      </CardHeader>
      <CardContent className="p-4 pt-0">
        <dl className="space-y-1 text-sm">
          {entries.map(([key, value]) => (
            <div key={key} className="flex justify-between gap-2">
              <dt className="text-muted-foreground capitalize">{key.replace(/([A-Z])/g, ' $1').trim()}</dt>
              <dd className="font-medium text-right">{String(value)}</dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
